module.exports = __webpack_public_path__ + "img/yyzz.06544775.png";